import { CORRECTNESS_LABEL, type Correctness } from '../lib/predict'

const CLASSES: Record<Correctness, string> = {
  correct: 'bg-benign/15 text-benign border-benign/30',
  wrong: 'bg-malignant/15 text-malignant border-malignant/30',
  borderline: 'bg-warn/15 text-warn border-warn/30',
  unknown: 'bg-surface-2 text-text-dim border-border',
}

const ICON: Record<Correctness, string> = {
  correct: '✓',
  wrong: '✗',
  borderline: '~',
  unknown: '?',
}

interface Props {
  correctness: Correctness
  size?: 'sm' | 'md'
  iconOnly?: boolean
}

export function CorrectnessBadge({ correctness, size = 'sm', iconOnly = false }: Props) {
  if (correctness === 'unknown') return null
  const sizeCls = size === 'md' ? 'text-xs px-2 py-0.5' : 'text-[10px] px-1.5 py-0.5'
  return (
    <span
      className={`inline-flex items-center gap-1 rounded border ${sizeCls} ${CLASSES[correctness]}`}
      title={CORRECTNESS_LABEL[correctness]}
    >
      <span className="font-semibold">{ICON[correctness]}</span>
      {!iconOnly && <span>{CORRECTNESS_LABEL[correctness]}</span>}
    </span>
  )
}
